import { Box, Text } from '@indeed/ifl-components';
import Heading from '../heading';
import { SearchComponentProps } from '../../types';
import styled from "@emotion/styled";

const SearchTerms: React.FC<SearchComponentProps> = ({
  label,
  terms,
  percentStrings,
  info,
  locale,
}) => {
  const percents = percentStrings.map(parseFloat); // Returns NaN on failed parsed
  // The percents are expected to be sorted in descending order, but this will work even if they're not
  const highestPercentMax = Math.max(...percents); // Returns -Infinity for an empty list
  const highestPercent = !Number.isNaN(highestPercentMax) && highestPercentMax > 0 ? highestPercentMax : 100;
  const scaledPercents = percents.map((percent) => Number.isNaN(percent) ? 100 : percent / highestPercent * 100);
  const PartialBoxBefore = styled.div<{ elementPercent: number }>`
    position: relative;
    margin-bottom: 0.5rem;
    border: 1px solid rgb(212, 210, 208);
    &:before {
      content: "";
      position: absolute;
      left: 0px;
      top: 0px;
      bottom: 0px;
      width: ${({ elementPercent = 0 }) => elementPercent}%;
      background-color: rgb(238, 241, 254);
      z-index: -10;
    }
  `;
  return (
    <Box>
      <Heading
        text={label}
        tooltipText={info}
        tooltipLabel={`More information about ${label}`}
      />
      <Box sx={{ pl: 5, mx: 0, pr: 5 }}>
        {terms.map((term, index) => (
          <PartialBoxBefore elementPercent={scaledPercents[index]} key={term}>
            {/* To push the percent to the right: display:flex on the outer box, flex-grow the span with the term */}
            <Box sx={{ display: "flex", flexDirection: "row", py: 1, pl: 2, m: 1 }}>
              <Text sx={{ flexGrow: 1, flexShrink: 1 }}>{index+1}. {term}</Text>
              {/* This skips the percent sign as well if there's not a percent for this index */}
              {percentStrings[index] && (<Text>{percentStrings[index]}%</Text>)}
            </Box>
          </PartialBoxBefore>
        ))}
      </Box>
    </Box>
  );
};

export default SearchTerms;
